import { post } from '../client';

const BRAVO_CREATE_LEAD_URL =
  'https://systemtest-orientsoftware.azurewebsites.net/api/OSDService/CreateBravoLead';

export default (data) => {
  return post(BRAVO_CREATE_LEAD_URL, data);
};
